import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TabsModule } from "ngx-bootstrap/tabs";
import { UiSwitchModule } from "ngx-ui-switch";
import { RequestCreationRoutingModule } from "./request-creation-routing.module";
import { RequestHeaderComponent } from "./request-header/request-header.component";
import { SharedModule } from "../shared/shared.module";
import { SeedNeedsUploadComponent } from "./experiment-design/seed-needs-upload/seed-needs-upload.component";
import { AccordionModule } from "ngx-bootstrap/accordion";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { PottingInstructionsComponent } from "./experiment-design/potting-instructions/potting-instructions.component";
import { PottingInstructionsFormComponent } from "./experiment-design/potting-instructions/potting-instructions-form/potting-instructions-form.component";
import { PlantingInstructionsComponent } from "./experiment-design/planting-instructions/planting-instructions.component";
import { SprayBoothStudyComponent } from "./experiment-design/spray-booth-study/spray-booth-study.component";
import { SprayBoothStudyFormComponent } from "./experiment-design/spray-booth-study/spray-booth-study-form/spray-booth-study-form.component";
import { PlantingInstructionsFormComponent } from "./experiment-design/planting-instructions/planting-instructions-form/planting-instructions-form.component";
import { RecurrenceComponent } from "./experiment-design/recurrence/recurrence.component";
import { PollinationInstructionsComponent } from "./experiment-design/pollination-instructions/pollination-instructions.component";
import { ExperimentDesignFormComponent } from "./experiment-design/experiment-design-form/experiment-design-form.component";
import { ExperimentDesignFormPageComponent } from "./experiment-design/experiment-design-form-page/experiment-design-form-page.component";
import { TreatmentCountInputComponent } from "./experiment-design/treatment-count-input/treatment-count-input.component";
import { ExperimentDetailsFormComponent } from "./experiment-details/experiment-details-form/experiment-details-form.component";
import { ExperimentDetailsFormPageComponent } from "./experiment-details/experiment-details-form-page/experiment-details-form-page.component";
import { PlantHandlingInstructionsComponent } from "./experiment-design/plant-handling-instructions/plant-handling-instructions.component";
import { PlantHandlingInstructionsFormComponent } from "./experiment-design/plant-handling-instructions/plant-handling-instructions-form/plant-handling-instructions-form.component";
import { HarvestInstructionsComponent } from "./experiment-design/harvest-instructions/harvest-instructions.component";
import { SamplingNeedsComponent } from "./experiment-design/sampling-needs/sampling-needs.component";
import { FlatInstructionsFormComponent } from './experiment-design/flat-instructions/flat-instructions-form/flat-instructions-form.component';
import { FlatInstructionsComponent } from './experiment-design/flat-instructions/flat-instructions.component';
import { UserRoleGuard } from "./user-role-guard";
import { SamplingNeedsFormComponent } from "./experiment-design/sampling-needs/sampling-needs-form/sampling-needs-form.component";
import { ResolvedRequestOptionsService } from "./services/resolved-request-options";
import { PollinationPreferenceGroupComponent } from "./experiment-design/pollination-instructions/pollination-preference-group/pollination-preference-group.component";
import { PollinationPreferenceItemListComponent } from "./experiment-design/pollination-instructions/pollination-preference-group/pollination-preference-item-list/pollination-preference-item-list.component";
import { PollinationStakeLabelComponent } from "./experiment-design/pollination-instructions/pollination-stake-label/pollination-stake-label.component";
import { NgxDnDModule } from "@swimlane/ngx-dnd";
import { ExperimentDesignShowHideService } from "./services/experiment-design-show-hide.service";
import { ExperimentDetailsShowHideService } from "./services/experiment-details-show-hide.service";
import { SeedRequestsComponent } from './experiment-design/seed-requests/seed-requests.component';
import { ResolvedSeedRequestsService } from "./services/resolved-seed-requests.module";

@NgModule({
  imports: [
    CommonModule,
    RequestCreationRoutingModule,
    FormsModule,
    TabsModule.forRoot(),
    AccordionModule.forRoot(),
    ReactiveFormsModule,
    SharedModule,
    UiSwitchModule,
    TooltipModule.forRoot(),
    NgxDnDModule
  ],
  declarations: [
    RequestHeaderComponent,
    SeedNeedsUploadComponent,
    PlantingInstructionsComponent,
    PlantingInstructionsFormComponent,
    PottingInstructionsComponent,
    PottingInstructionsFormComponent,
    RecurrenceComponent,
    PollinationInstructionsComponent,
    ExperimentDesignFormComponent,
    ExperimentDesignFormPageComponent,
    TreatmentCountInputComponent,
    ExperimentDetailsFormComponent,
    ExperimentDetailsFormPageComponent,
    PlantHandlingInstructionsComponent,
    PlantHandlingInstructionsFormComponent,
    SprayBoothStudyComponent,
    SprayBoothStudyFormComponent,
    HarvestInstructionsComponent,
    SamplingNeedsComponent,
    FlatInstructionsFormComponent,
    FlatInstructionsComponent,
    SamplingNeedsFormComponent,
    PollinationPreferenceGroupComponent,
    PollinationPreferenceItemListComponent,
    PollinationStakeLabelComponent,
    SeedRequestsComponent
  ],
  providers: [
    UserRoleGuard,
    ResolvedRequestOptionsService,
    ResolvedSeedRequestsService,
    ExperimentDesignShowHideService,
    ExperimentDetailsShowHideService
  ],
  exports: [
    RequestHeaderComponent,
    ExperimentDesignFormPageComponent,
    ExperimentDetailsFormPageComponent
  ]
})
export class RequestCreationModule {}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/request-creation.module.ts